import { formatDateTime } from "@/lib/api";

/**
 * Small footer that shows creator + last-edited info on any entity.
 * Pass the entity document and it pulls whatever metadata it has.
 */
export default function MetadataFooter({ entity, className = "" }) {
  if (!entity) return null;
  const showCreated = entity.created_by_name || entity.created_at;
  const showUpdated =
    entity.updated_at && entity.updated_at !== entity.created_at && entity.updated_by_name;

  if (!showCreated && !showUpdated) return null;

  return (
    <div className={`text-xs text-[#1E3A8A] space-y-0.5 ${className}`} data-testid="metadata-footer">
      {showCreated && (
        <div>
          <span className="text-[#334155]">Added</span>
          {entity.created_by_name && <> by <span className="text-[#334155]">{entity.created_by_name}</span></>}
          {entity.created_at && <> on {formatDateTime(entity.created_at)}</>}
        </div>
      )}
      {showUpdated && (
        <div>
          <span className="text-[#334155]">Last edited</span>
          {entity.updated_by_name && <> by <span className="text-[#334155]">{entity.updated_by_name}</span></>}
          {entity.updated_at && <> on {formatDateTime(entity.updated_at)}</>}
        </div>
      )}
    </div>
  );
}
